var map = {
	"./etiquette.png": 1674,
	"./flgrief.jpg": 1675,
	"./fllocations.jpg": 1676,
	"./flplanning.jpg": 1677,
	"./grief.png": 1678,
	"./obitwriter.png": 1679,
	"./planning.png": 1680
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1673;


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/ResourcesBlock/assets ^\.\/.*$
// module id = 1673
// module chunks = 0